import { FC } from "react";
import { Column } from "../../components/containers";
import Socials from "./socials";
import LoginForm from "./login-form";
import { JustifyContent } from "../../components/containers/types";
import { useAuth } from "../../hooks";

const Login: FC = () => {
  const loading = useAuth(false);

  if (loading) return <></>;
  return (
    <Column
      className="login direction-rtl"
      justifyContent={JustifyContent.Center}
    >
      <img
        src={require("../../assets/images/login-bg.png")}
        alt="login-bg"
        className="login-bg"
      />
      <Socials />
      <LoginForm />
    </Column>
  );
};

export default Login;
